(() => {
  const mobile = window.matchMedia('(max-width: 767px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('[data-collection-benefits]').forEach(strip => {
    const benefits = [...strip.children].filter(item => item.tagName === 'DIV');
    const buttons = [...strip.querySelectorAll('[data-benefit-index]')];
    if (benefits.length < 2 || buttons.length !== benefits.length) return;

    let index = 0;
    let timer;
    let pointerStart;
    let hovered = false;
    let userPaused = false;

    const show = next => {
      index = (next + benefits.length) % benefits.length;
      benefits.forEach((benefit, position) => {
        const active = position === index;
        benefit.classList.toggle('is-active', active);
        benefit.hidden = mobile.matches && !active;
      });
      buttons.forEach((button, position) => {
        button.setAttribute('aria-pressed', String(position === index));
        button.setAttribute('aria-label', benefits[position].textContent.trim());
      });
      strip.dataset.benefitsReady = '';
    };

    const update = () => {
      clearInterval(timer);
      show(index);
      if (mobile.matches && !document.hidden && !reducedMotion.matches && !hovered && !userPaused && !strip.contains(document.activeElement)) {
        timer = setInterval(() => show(index + 1), 5000);
      }
    };

    buttons.forEach((button, position) => {
      button.addEventListener('click', () => {
        userPaused = true;
        show(position);
        update();
      });
      button.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        userPaused = true;
        const next = (position + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
        buttons[next].focus();
        show(next);
        update();
      });
    });

    strip.addEventListener('pointerdown', event => {
      if (event.pointerType === 'touch') pointerStart = event.clientX;
    });
    strip.addEventListener('pointerup', event => {
      if (pointerStart === undefined) return;
      const distance = event.clientX - pointerStart;
      pointerStart = undefined;
      if (Math.abs(distance) > 35) {
        userPaused = true;
        show(index + (distance < 0 ? 1 : -1));
        update();
      }
    });
    strip.addEventListener('pointercancel', () => { pointerStart = undefined; });
    strip.addEventListener('mouseenter', () => { hovered = true; update(); });
    strip.addEventListener('mouseleave', () => { hovered = false; update(); });
    strip.addEventListener('focusin', update);
    strip.addEventListener('focusout', () => queueMicrotask(update));
    mobile.addEventListener('change', update);
    reducedMotion.addEventListener('change', update);
    document.addEventListener('visibilitychange', update);
    update();
  });
})();
